export default __webpack_public_path__ + "static/media/BO.b1a8c7ba.svg";